import { getHeaders, makeRequest } from "$utils/utils";
import constants from "$utils/constants";

export enum ERRORS {
  EXISTS = "Cet produit existe déjà !",
  ADD_ERROR = "Une erreur s'est produite lors de l'ajout d'un produit",
  UPDATE_ERROR = "Une erreur s'est produite lors de l'édition du coordinateur",
  MISSING_FIELD = "Donnée manquante !",
}

export const addProduct = async (token: string, data: any) => {
  try {
    const res = await makeRequest(
      constants.API.ENDPOINTS.PRODUCT.ADD,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when adding user");
    }
    return res;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("user already exists")) {
      error = ERRORS.EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export async function importCSV(token: string, data: any) {
  try {
    const dataWithFileMetadata: any = {
      ...data,
      csv: {
        ...data.csv,
        file: {
          ...data.csv.file,
          modifiedAt: data.csv.file.lastModified,
          size: data.csv.file.size,
          name: data.csv.file.name,
        },
      },
    };

    const res = await makeRequest(
      constants.API.ENDPOINTS.STOCK,
      "POST",
      dataWithFileMetadata,
      getHeaders(token)
    );
    if (!res || !res.data) {
      throw new Error("Error when adding product");
    }
    return res;
  } catch (err: any) {
    console.error(err);
    return { error: (err as any)?.response?.data?.message };
  }
}

export const getStock = async (token: string, company = "") => {
  const response = await makeRequest(
    `${constants.API.ENDPOINTS.STOCK}?company=${company}`,
    "GET",
    undefined,
    getHeaders(token)
  );

  return response;
};

export const getFileUrl = async (
  token: string,
  companyId: string,
  entrepotId: string
) => {
  const queryParams =
    companyId && entrepotId
      ? `company=${companyId}&entrepot=${entrepotId}`
      : `company=${companyId}`;
  const response = await makeRequest(
    `${constants.API.ENDPOINTS.STOCK}/url?${queryParams}`,
    "GET",
    undefined,
    getHeaders(token)
  );
  return response;
};
export default { getStock, importCSV, getFileUrl };
